module.exports = __webpack_public_path__ + "img/1522538540.a74f547e.jpg";